<template>
  <div>
    {{ text_body }}
    <a href="javascript:void(0);" class="link" @click="download">{{ text_link }}</a>
  </div>
</template>

<script>
  export default {
    props: {
      path: {
        required: true,
        type: String
      },
      text_link: {
        type: String,
        required: true
      },
      text_body: {
        type: String,
        required: true
      },
      file_id: {
        type: [Number, String],
        required: true,
        default: ''
      }
    },

    methods: {
      download() {
        location.href = this.path;
      }
    }
  };
</script>
